import { render } from "./service.vue?vue&type=template&id=63fc87a2&scoped=true&ts=true"
import script from "./service.vue?vue&type=script&lang=ts"
export * from "./service.vue?vue&type=script&lang=ts"

import "./service.vue?vue&type=style&index=0&id=63fc87a2&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fc87a2"]])

export default __exports__